export default {
  general: {
    send: 'сенд',
    loading: 'Loading',
  },
};
